import { Alert, Button, Modal } from 'react-bootstrap'

interface IProps {
    errorMessage: string,
    onCancel: () => void
}

const ErrorMessageModal = (props: IProps) => {
    return (
        <Modal backdrop='static' show={props.errorMessage != ''} onHide={props.onCancel}>
            <Modal.Header closeButton>WARNING!</Modal.Header>
            <Modal.Body>
                <Alert bsStyle='warning' bsSize='sm'>{props.errorMessage}</Alert>
            </Modal.Body>
            <Modal.Footer>
                <Button bsStyle='primary' onClick={props.onCancel}>Ok</Button>
            </Modal.Footer>
        </Modal>
    );
}

export default ErrorMessageModal;